import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg className={styles["icon-svg"] || "icon-svg"} width="24" height="24" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M7 15.5h5m-9 0h2m2-4h9m-13 0h2m2-4h14m-18 0h2" stroke="currentColor" fill="none" /></svg>;